import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import TextField, { TextFieldAdornmentText } from 'components/fields/TextField';
import AutosuggestField from 'components/fields/AutosuggestField';
import FormError from 'components/common/FormError';

import { requestSearchUsers } from 'redux/modules/users';
import { accountLoginFail } from 'redux/modules/account';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';

import objectDiff from 'utils/objectDiff';

const styles = () => ({
  grid: {
    marginTop: 10,
    '&:first-child': {
      marginTop: 0,
    },
  },
});

const WatcherAddForm = ({
  className,
  handleSubmit,
  actions,
  change,
  Watcher,
  onFocus,
  onBlur,
  classes,
}) => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
    className={className}
  >
    <Field
      id="Watcher Name"
      name="Watcher Name"
      placeholder="Add Other Watcher"
      component={AutosuggestField}
      fullWidth
      renderSuggestionContent={suggestion =>
        `${suggestion['First Name']} ${suggestion['Last Name']}`}
      renderInputContent={suggestion =>
        `${suggestion['First Name']} ${suggestion['Last Name']}`}
      onSuggestionSelected={(suggestion) => {
        change('Watcher ID', suggestion.ID);
        return '';
      }}
      fetchSuggestions={({ value, limit, offset }) => (
        value.length > 0 || Watcher.length > 0
          ? requestSearchUsers({
            filters: [
              {
                name: 'Role',
                operation: 'ne',
                val: 'System',
              },
              {
                name: 'Active',
                operation: 'eq',
                val: true,
              },
              ...value.length > 0
                ? [{
                  name: 'Full Name',
                  operation: 'startswith',
                  val: value,
                  case_sensitivity: false,
                }] : [],
              ...Watcher.length > 0
                ? Watcher.map(item => ({
                  name: 'ID',
                  operation: 'ne',
                  val: item.ID,
                }))
                : [],
            ],
            limit,
            offset,
          }).then(res => res.data,
            (err) => {
              if (err.data.error === 'Need authorisation') {
                actions.accountLoginFail();
              }
              return err;
            })
          : requestSearchUsers({
            filters: [
              {
                name: 'Role',
                operation: 'ne',
                val: 'System',
              },
              {
                name: 'Active',
                operation: 'eq',
                val: true,
              },
            ],
            limit,
            offset,
          }).then(res => res.data,
            (err) => {
              if (err.data.error === 'Need authorisation') {
                actions.accountLoginFail();
              }
              return err;
            })
      )}
      listWidth="auto"
      onlyConfirmedSelection
      clearSearchValueAfterSelection
      onFocus={onFocus}
      onBlur={onBlur}
    />
  </form>
);

WatcherAddForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
  }).isRequired,
};

WatcherAddForm.defaultProps = {
  className: '',
  error: null,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountLoginFail }, dispatch),
});

export default connect(null, mapDispatchToProps)(reduxForm({
  form: 'watcherAdd',
})(withStyles(styles)(WatcherAddForm)));



// WEBPACK FOOTER //
// ./src/components/patient/Watchers/WatcherAddForm.js